import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SupportRequest } from './support-request/support-request';

@Injectable()
export class SupportRequestService {
  readonly saveUrl = '/supportrequest/submitsupportrequest';

  constructor(private http: HttpClient) { }

  getSupportRequests(): SupportRequest[] {
    return [];
  }

  newSupportRequest(request: SupportRequest): Observable<SupportRequest> {
    return this.http.post<SupportRequest>(this.saveUrl, request);
  }

}

let supportRequestServiceStub: Partial<SupportRequestService> = {};
export { supportRequestServiceStub };